import { render } from "./Borders.vue?vue&type=template&id=63473c3c&scoped=true"
import script from "./Borders.vue?vue&type=script&lang=ts"
export * from "./Borders.vue?vue&type=script&lang=ts"

import "./Borders.vue?vue&type=style&index=0&id=63473c3c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-63473c3c"

export default script